/** AsyncStorage key for a B2B org join code awaiting post-sign-in processing. */
export const PENDING_B2B_JOIN_STORAGE_KEY = '@zporti/pending_b2b_org_join';

/** Web sessionStorage mirror — survives OAuth redirect in the same tab. */
export const PENDING_B2B_JOIN_SESSION_KEY = 'zporti_pending_b2b_org_join';

/** Drop stale pending codes after 7 days. */
export const PENDING_B2B_JOIN_TTL_MS = 7 * 24 * 60 * 60 * 1000;
